import React , { useState , useEffect} from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { FormProvider , RHFTextField } from '../../../components/hook-form' ;
import * as Yup from "yup";
import { useTheme } from "@emotion/react";
import Select from 'react-select';
import Async from "react-select/async";
import makeAnimated from 'react-select/animated';
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import { LoadingButton } from "@mui/lab";
import { Typography , Stack , Button , MenuItem } from '@mui/material';
const ExtendBatch = ({ batchId, setOpen, userDetails,setRefresh}) => {
    console.log(userDetails);
    const theme = useTheme();
    const animatedComponents = makeAnimated();
    const [loading, setLoading] = useState(false);
    const registerSchema = Yup.object().shape({
      transactionId: Yup.string().required('Transaction ID Required'),
      amount: Yup.string().required('Amount Required'),
      remark:Yup.string('Remark?').max(500)
    });
    const defaultValues = {
       batchId : batchId,
       transactionId : "",
       amount : "",
       userIdArr : []
    };
    const methods = useForm({
      resolver: yupResolver(registerSchema),
      defaultValues,
    });
    const {
      handleSubmit,
      reset,
      formState: { isSubmitting },
    } = methods;
    const [list , setList] = useState([]);
    useEffect(() => {
        const token = localStorage.getItem("token");
        async function fetchDetails() {
            const fullResponse = await fetch(
                `${process.env.REACT_APP_LIVE_URL}/adminSection/getValidityofBatch/${batchId}`,
                {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                }
            );
            const responseJson = await fullResponse.json();
            setList(responseJson?.data);
        }
        fetchDetails();
        setLoading(false);
        
    }, []);
    const onSubmit = async (data) => {
      // console.log(data)
      const token = localStorage.getItem("token");
      const authToken = token;
      setLoading(true);
      const config = {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      };
      const reqData = {
        "userIdArr": [userDetails?.user_id],
        "batchId": batchId,
        "transactionId":data.transactionId,
        "amount":data.amount,
        "validityId" :  data.validity,
        "remark" :  data?.remark,
      }
      await axios
      .post(
        `${process.env.REACT_APP_LIVE_URL}/adminPanel/extendBatchValidity`,
        // data,
        reqData,
        config
      )
      .then((response) => {
        // console.log(response.data.msg);
        if(response.data.status){
            setTimeout(() => {
                setLoading(false);
                setOpen(false);
                setRefresh(prev => !prev); // stop refreshing after delay
            }, 6000);

            toast.success(response.data.msg, { autoClose: 3000 });
          
        }else{
          // console.log("Erorr")
          toast.error(response.data.msg);
          setLoading(false)
        }
        
      })
      .catch((e) => {
        toast.error(e, { autoClose: true });
        // setOpen()
        //console.log(e);
      });
    }
    return (
      <>
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <Typography variant="h4" align="center" mb={2}>
            Extend Student Batch
          </Typography>
          <Stack direction="column" spacing={3}>
                <RHFTextField name={'userId'} value={`${userDetails?.namePhoto?.name}-${userDetails?.mobileNumber}`} disabled/>
                <RHFTextField name="transactionId" label="Transaction Id *" />
                <RHFTextField name="amount" label="Amount *" />
                <RHFTextField
                                name='validity'
                                label="Select Validity Plan *"
                                sx={{ width: '100%' }}
                                select
                >
                   {list?.map((item, index) => (
                      <MenuItem  value={item?.value} key={index}>{item?.label } </MenuItem>

                  )) }
                </RHFTextField>
                <RHFTextField name="remark" label="Remark (Optional)" />
               
          </Stack>
         
          <Stack
            direction="row"
            spacing={2}
            m={3}
            align="center"
            justifyContent="space-evenly"
          >
            <Button
              variant="contained"
              style={{
                backgroundColor: theme.palette.primary.mainTheme,
                color: "white",
                "&:hover": { background: "red" },
              }}
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
           
            <LoadingButton size="large" type="submit" variant="contained" disabled={userDetails?.user_id == ''} loading={loading}
              sx={{ bgcolor: theme.palette.primary.mainTheme, marginTop: '5%', '&:hover': { background: theme.palette.primary.mainTheme } }}>
              Extend
            </LoadingButton>
          </Stack>
          <ToastContainer
            position="bottom-center"
            autoClose={1000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </FormProvider>
      </>
    );
}

export default ExtendBatch